/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：857
 */

"use strict"

var r = "undefined" !== typeof self ? self : "undefined" !== typeof window ? window : undefined
var /* [auto-meaningful-name] */r$AbortController = r.AbortController
var /* [auto-meaningful-name] */r$AbortSignal = r.AbortSignal
module.exports = r$AbortController
module.exports.AbortSignal = r$AbortSignal
module.exports.default = r$AbortController
